<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">{{ $t('app.filter_by') }}</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.name')}}</label>
              <el-form-item prop="name">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.name.value"
                  maxlength="50"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('configurations.prioridad')}}</label>
              <el-form-item prop="prioridad">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.prioridad.value"
                  min="0"
                  max="9999999999"
                  type="number"
                />
              </el-form-item>
            </div>
            
             <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.active')}}</label>
              <el-form-item prop="activo">
                <el-select class="w-full" v-model="form.activo.value" clearable :placeholder="$t('companies.active_yes_no')">
                    <el-option
                      v-for="item in values"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
              </el-form-item>
            </div>

             <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('rules.detener_ejecucion')}}</label>
              <el-form-item prop="activo">
                <el-select class="w-full" v-model="form.DetenerEjecucion.value" clearable :placeholder="$t('rules.detener_ejecucion_yes_no')">
                    <el-option
                      v-for="item in values"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
              </el-form-item>
            </div>
            
             <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('configurations.en_emision')}}</label>
              <el-form-item prop="EnEmision">
                <el-select class="w-full" v-model="form.EnEmision.value" clearable :placeholder="$t('configurations.en_emision_yes_no')">
                    <el-option
                      v-for="item in values"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
              </el-form-item>
            </div>

             <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('configurations.envia_auto')}}</label>
              <el-form-item prop="EnviarAutomaticamente">
                <el-select class="w-full" v-model="form.EnviarAutomaticamente.value" clearable :placeholder="$t('configurations.envia_auto_yes_no')">
                    <el-option
                      v-for="item in values"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('groups.entity_name')}}</label>
              <el-form-item prop="nombreGrupo">
                <base-el-select class="w-full" :groups="listaGroupsGrouping" v-model="form.nombreGrupo.value" clearable filterable :loading="loadingGrupos" />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('groups.group_owner')}}</label>
              <el-form-item prop="nombreGrupoPropietario">
                <base-el-select class="w-full" :groups="listaGroupsGroupingOwner" v-model="form.nombreGrupoPropietario.value" clearable filterable :loading="loadingGrupos" />
              </el-form-item>
            </div>

             <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.in_use')}}</label>
              <el-form-item prop="enUso">
                <el-select class="w-full" v-model="form.enUso.value" clearable :placeholder="$t('app.filters.en_uso_yes_no')">
                    <el-option
                      v-for="item in values"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
              </el-form-item>
            </div>

          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>

<script>
import { i18n } from '@/i18n'
import { getGroupsNames } from '@/services/configurations/groups/getGroupsNames'

export default {
  /* eslint-disable camelcase */
  name: 'filter-panel',
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      vuexnamespace: 'grouprules',
      isOpen: this.panelOpen,
      loadingGrupos: false,
      links: [],
      form: {
        id: { label: i18n.t('app.id'), value: '' },
        name: { label: i18n.t('app.name'), value: '' },
        prioridad: { label: i18n.t('configurations.prioridad'), value: '' },
        enUso: { label: i18n.t('app.in_use'), value: '' },
        activo: { label: i18n.t('app.active'), value: '' },
        DetenerEjecucion: { label: i18n.t('rules.detener_ejecucion'), value: '' },
        EnEmision: { label: i18n.t('configurations.en_emision'), value: '' },
        EnviarAutomaticamente: { label: i18n.t('configurations.envia_auto'), value: '' },
        nombreGrupo: { label: i18n.t('groups.entity_name'), value: '' },
        nombreGrupoPropietario: { label: i18n.t('groups.group_owner'), value: '' },
        distribuidor: { label: i18n.t('distributors.entity_name'), value: '' },
        empresa: { label: i18n.t('clients.entity_name'), value: '' },
      },
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      valuesNombresGrupos: [],
    }
  },

  watch: {
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  mounted: async function () {
    this.loadingGrupos = true
    const gruposUsuario = await getGroupsNames()
    if (gruposUsuario.blnError) {
      this.doFeedback(i18n.t('feedback.error.formated_api_response_error', gruposUsuario))
    } else {
      this.valuesNombresGrupos = gruposUsuario.Respuesta
    }
    this.loadingGrupos = false
  },
  computed: {
    listaGroupsGrouping () {
      const groupTypes = this.tiposGrupo.reduce((acc, x) => ({ ...acc, [x.id]: x }), {})
      return this.valuesNombresGrupos.reduce((a, b) => ({ ...a, [groupTypes[b.idTipoGrupo]?.name]: [...(a[groupTypes[b.idTipoGrupo]?.name] || []), b] }), {})
    },
    listaGroupsGroupingOwner () {
      const tipoReparto = this.tiposGrupo.find(x => x.id === 3)?.name ?? 'Reparto'
      return this.discard([tipoReparto], this.listaGroupsGrouping)
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    tiposGrupo: function () {
      return this.$store.getters['config/TIPOS_GRUPO']
    }
  },
  methods: {
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.id.value = _temp.id !== undefined && _temp.id.value !== '' ? _temp.id.value : ''
        this.form.name.value = _temp.name !== undefined && _temp.name.value !== '' ? _temp.name.value : ''
        this.form.prioridad.value = _temp.prioridad !== undefined && _temp.prioridad.value !== '' ? _temp.prioridad.value : ''
        this.form.enUso.value = _temp.enUso !== undefined && _temp.enUso.value !== '' ? _temp.enUso.value : ''
        this.form.activo.value = _temp.activo !== undefined && _temp.activo.value !== '' ? _temp.activo.value : ''
        this.form.DetenerEjecucion.value = _temp.DetenerEjecucion !== undefined && _temp.DetenerEjecucion.value !== '' ? _temp.DetenerEjecucion.value : ''
        this.form.EnEmision.value = _temp.EnEmision !== undefined && _temp.EnEmision.value !== '' ? _temp.EnEmision.value : ''
        this.form.EnviarAutomaticamente.value = _temp.EnviarAutomaticamente !== undefined && _temp.EnviarAutomaticamente.value !== '' ? _temp.EnviarAutomaticamente.value : ''
        this.form.nombreGrupo.value = _temp.nombreGrupo !== undefined && _temp.nombreGrupo.value !== '' ? _temp.nombreGrupo.value : ''
        this.form.nombreGrupoPropietario.value = _temp.nombreGrupoPropietario !== undefined && _temp.nombreGrupoPropietario.value !== '' ? _temp.nombreGrupoPropietario.value : ''
      }
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        id: { label: i18n.t('app.id'), value: '' },
        name: { label: i18n.t('app.name'), value: '' },
        prioridad: { label: i18n.t('configurations.prioridad'), value: '' },
        enUso: { label: i18n.t('app.in_use'), value: '' },
        activo: { label: i18n.t('app.active'), value: '' },
        DetenerEjecucion: { label: i18n.t('rules.detener_ejecucion'), value: '' },
        EnEmision: { label: i18n.t('configurations.en_emision'), value: '' },
        EnviarAutomaticamente: { label: i18n.t('configurations.envia_auto'), value: '' },
        nombreGrupo: { label: i18n.t('groups.entity_name'), value: '' },
        nombreGrupoPropietario: { label: i18n.t('groups.group_owner'), value: '' },
        distribuidor: { label: i18n.t('distributors.entity_name'), value: '' },
        empresa: { label: i18n.t('clients.entity_name'), value: '' },
      }
    },
    applyFilters: function () {
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    },
  }
}
</script>
